import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { urlFormatter } from './urlFormatter';
import { v4 as uuidV4 } from 'uuid';
import { YouTubeURLParser } from '@iktakahiro/youtube-url-parser';
import { unescape } from 'lodash';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

export const reactUrlFormatter = (text: string) => {
	return urlFormatter(text, (path) => {
		let content = <>{path}</>;
		if (
			['.jpg', '.jpeg', '.png', '.gif', '.bmp', 'data:image/'].some((check) =>
				path.includes(check),
			)
		) {
			content = <Image src={path} className="image" alt="" />;
		} else if (['youtu.be', 'youtube'].some((check) => path.includes(check))) {
			const youtubeUrl = new YouTubeURLParser(path);
			const videoID = youtubeUrl.getId();

			if (videoID) {
				content = <IFrame videoID={videoID} />;
			}
		} else {
			const url = unescape(path);
			content = (
				<a
					href={
						['http', 'https', 'ftp', 'ftps'].some((check) =>
							url.includes(check),
						)
							? url
							: `//${url}`
					}
					target="_blank"
					rel="noreferrer"
				>
					{url}
				</a>
			);
		}
		const htmlString = ReactDOMServer.renderToStaticMarkup(content);
		return htmlString;
	});
};

const IFrame = styled(
	({ className, videoID }: { className?: string; videoID: string }) => (
		<div className={classNames('iframe-container', className)}>
			<iframe
				id={uuidV4()}
				title={uuidV4()}
				src={`https://www.youtube.com/embed/${videoID}`}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		</div>
	),
	{ label: 'IFrame', target: 'IFrame-root' },
)({
	border: '1px solid var(--chat__frame_border)',
	'& iframe': {
		width: '100%',
		height: '100%',
	},
});

const Image = styled('img', { label: 'Image', target: 'Image-root' })({
	width: '100%',
	border: '1px solid var(--chat__frame_border)',
});
